import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { fetchStates } from "../../Actions";
const getStates = (state) => state.statesReducer;

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

export default function StateAutoComplete({
  disabled,
  updateValue,
  stateHandler,
  stateData,
  values,
  formStates,
  names,
  groupName
}) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const { statesfetched } = useSelector(getStates);
  const [stateSelect, setStateSelect] = React.useState([]);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(fetchStates());
  }, []);

  // This effect populates the state select options
  React.useEffect(() => {
    const createStateSelect = () => {
      let stateArray = [];

      statesfetched.map((state) => {
        let option = { value: state.stateID, label: state.stateName };
        return stateArray.push(option);
      });
      setStateSelect(stateArray);
    };
    statesfetched.length !== 0 && createStateSelect();
  }, [statesfetched]);

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3);
      if (active) {
        setOptions(stateSelect);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  React.useEffect(()=>{
    console.log(values)
  },[values])

  return (
    <>
      <Autocomplete
        sx={{marginTop:'10px'}}
       name ={names}
        onKeyDown={handleKeyDown}
        autoHighlight
        id="asynchronous-demo"
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        value={values || {label:"All", value:0}}
        onChange={(event, value) => {
          if (value) {
            stateHandler(event, value, names);
            // updateValue(value);
          }
        }}
        isOptionEqualToValue={(option, value) => option?.label === value?.label}
        getOptionLabel={(option) => option?.label || ""}
        options={options}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={groupName}
            variant="standard"
            InputProps={{
              ...params.InputProps,
              endAdornment:
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
             
            }}
          />
        )}
      />
    </>
  );
}
